import { Component, Input, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Insight, InsightAggregationData } from 'src/app/all-motivations/model/all-motivations.interface';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { AbstractMotivationsService } from 'src/app/moov-common/services/motivation/motivations.abstract.service';

@Component({
  selector: 'app-team-member-view-insights',
  templateUrl: './team-member-view-insights.component.html',
  styleUrls: ['./team-member-view-insights.component.scss']
})
export class TeamMemberViewInsightsComponent extends BaseComponent implements OnInit {
  @Input() counterpartId: string;
  retreivedCounterpartId: string = "";
  
  insights: Insight[] = [];
  insightsAgg: InsightAggregationData[];
  insightsRetreived: boolean;
  chips: string[] = [];

  motivationsImageRootFolder: string = 'assets/motivations/';
  
  constructor(public motivationService: AbstractMotivationsService, public motivationsService: AbstractMotivationsService, public translate: TranslateService) { 
    super();
    this.insightsRetreived = false;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.getInsightsForCounterpart();   
  }

  ngOnChanges(changes: SimpleChanges): void {
      // changes.counterpartId
      // console.log(`in TMVI changes are ${JSON.stringify(changes)}`);
      if (changes.counterpartId.currentValue != changes.counterpartId.previousValue && !changes.counterpartId.firstChange){
        this.getInsightsForCounterpart();
      }
  }

  getMotivaitonColor (motivationId: string): string{
    return this.motivationService.getMotivationColor(motivationId);
  }

  getInsightsForCounterpart(): void{
    // console.log (`in TMVI counterpartId is ${this.counterpartId} retCounterpartId is ${this.retreivedCounterpartId}`);
    if (this.counterpartId != undefined && this.counterpartId != ""){
      this.motivationService.insightsForCounterpart(this.counterpartId).subscribe(result => {
        this.insightsAgg = result;

        this.chips = this.insightsAgg.map(insightType => insightType.insightType.name)
        // this is temporary until the issue with the carosel (not updating data when it changes) will be resolved
        this.insightsRetreived = true;
        // console.log(`in TMVI insights are ${JSON.stringify(this.insightsAgg)}`);
        // console.log(`called insightsForCounterpart`);
        this.retreivedCounterpartId = this.counterpartId;
      });
    }
  }

  getMotivationIconName (motivationId: string): string{
    return this.motivationService.getMotivationIconName(motivationId);
  }

}
